<template>
  <div>
    <Row :gutter="20">
      <i-col :xs="12" :md="8" :lg="4" v-for="(infor, i) in inforCardData" :key="`infor-${i}`" style="height: 120px;padding-bottom: 10px;">
        <infor-card shadow :color="infor.color" :icon="infor.icon" :icon-size="36">
          <count-to :end="infor.count" count-class="count-style"/>
          <p>{{ infor.title }}</p>
        </infor-card>
      </i-col>
    </Row>
    <Row style="text-align: right">
      <Card shadow>
        <ButtonGroup style="margin-right: 10px;">
        <Button @click="getDeployTrend(7)">7天</Button>
        <Button @click="getDeployTrend(30)">1个月</Button>
        <Button @click="getDeployTrend(60)">2个月</Button>
        </ButtonGroup>
        <DeployTrend style="height: 310px;" :xData="xData" :yData="yData"/>
      </Card>
    </Row>
  </div>
</template>

<script>
import InforCard from '_c/info-card'
import CountTo from '_c/count-to'
import { ChartPie, ChartBar } from '_c/charts'
import { getNodeUse, getPodList, getPodUse } from '@/api/cloud'
import { getProjectDashboard, getDeployTrend } from '@/api/project'
import DeployTrend from './DeployTrend.vue'
export default {
  name: 'DeployDashboard',
  components: {
    InforCard,
    CountTo,
    ChartPie,
    ChartBar,
    DeployTrend
  },
  data () {
    return {
      inforCardData: [],
      nodeArray: [],
      podArray: [],
      countTotal: 0,
      countSuccess: 0,
      countBack: 0,
      countFail: 0,
      xData: [],
      yData: [],
      nodeSel: null,
      podSel: null,
      nodeCpu: null,
      cpuUse: 20,
      memUse: 310,
      podCpu: 0,
      podMem: 0,
      pieDataNodeCpu: [],
      pieDataNodeMem: [],
      pieDataPodCpu: {},
      pieDataPodMem: {}
    }
  },
  methods: {
    getProjectDashboard () {
      getProjectDashboard().then(res => {
        let totalProjectJson = { title: '应用总数', icon: 'ios-apps-outline', count: 803, color: '#2d8cf0' }
        let myProjectJson = { title: '我的项目', icon: 'ios-contact-outline', count: 803, color: '#2d8cf0' }
        let successJson = { title: '发布成功', icon: 'ios-checkmark-circle-outline', count: 232, color: '#19be6b' }
        let backJson = { title: '回滚数量', icon: 'md-arrow-back', count: 657, color: '#E46CBB' }
        let failJson = { title: '发布失败', icon: 'ios-close-circle-outline', count: 142, color: '#ed3f14' }
        let totalJson = { title: '总发布数', icon: 'ios-arrow-dropup', count: 142, color: '#ff9900' }
        totalJson['count'] = res.data.project.count_total
        successJson['count'] = res.data.project.count_success
        backJson['count'] = res.data.project.count_back
        failJson['count'] = res.data.project.count_fail
        totalProjectJson['count'] = res.data.project.project_count_all
        myProjectJson['count'] = res.data.project.project_count
        this.inforCardData.push(totalProjectJson)
        this.inforCardData.push(myProjectJson)
        this.inforCardData.push(totalJson)
        this.inforCardData.push(successJson)
        this.inforCardData.push(backJson)
        this.inforCardData.push(failJson)
      })
    },
    getDeployTrend (value) {
      let params = {
        search: value
      }
      getDeployTrend(params).then(res => {
        this.xData = res.data.map(item => item[0])
        this.yData = res.data.map(item => item[1])
      })
    },
    getPodList () {
      getPodList().then(res => {
        this.podArray = res.data
      })
    },
    handleNodeOnChange (value) {
      this.getNodeUse(value)
      this.getPodList(value)
    },
    handlePodOnChange (value) {
      this.getPodUse(value)
    },
    getNodeUse (value) {
      let that = this
      that.pieDataNodeCpu = []
      that.pieDataNodeMem = []
      // 读取选择节点的 使用情况
      getNodeUse(value).then(res => {
        let valueCpu1 = { value: res.data.cpu_usage, name: '已使用(m)' }
        let valueCpu2 = { value: res.data.free_cpu, name: '空闲(m)' }
        let valueMem1 = { value: res.data.mem_usage, name: '已使用(Mi)' }
        let valueMem2 = { value: res.data.free_mem, name: '空闲(Mi)' }
        that.pieDataNodeCpu.push(valueCpu1)
        that.pieDataNodeCpu.push(valueCpu2)
        that.pieDataNodeMem.push(valueMem1)
        that.pieDataNodeMem.push(valueMem2)
      })
    },
    // 得到当前选择的Node的相关pod监控情况
    getPodUse (value) {
      let that = this
      that.pieDataPodCpu = {}
      that.pieDataPodMem = {}
      // 读取选择节点的 使用情况
      getPodUse(value).then(res => {
        let key1 = res.data.time
        let cpuData = {}
        let menData = {}
        cpuData[key1] = res.data.cpu_usage
        menData[key1] = res.data.mem_usage
        that.pieDataPodCpu = cpuData
        that.pieDataPodMem = menData
      })
    }
  },
  mounted () {
    this.getProjectDashboard()
    this.getDeployTrend(30)
  }
}
</script>

<style lang="less" scoped>
.count-style{
  font-size: 50px;
}
@baseColor: ~"#dc9387";
.countto-page-row{
  height: 200px;
}
.count-to-con{
  display: block;
  width: 100%;
  text-align: center;
}
.count-text{
  font-size: 50px;
  color: @baseColor;
}
.slot-text{
  font-size: 22px;
}
.unit-class{
  font-size: 30px;
  color: @baseColor;
}
</style>
